import React from 'react';
import PropTypes from 'prop-types';

import './Button.css';

const Button = ({
  label,
  activeLabel,
  type,
  size,
  color,
  isActive,
  isDisabled,
  isFullWidth,
  title,
  handler,
  className,
  style,
}) => {
  const btnLabel = !isActive ? label : activeLabel;

  const classes = [
    'button',
    size && `is-${size}`,
    color && `is-${color}`,
    isFullWidth && 'is-fullwidth',
    isActive && !activeLabel && 'button--active is-loading',
    className,
  ].filter(c => c);

  return (
    <button style={style} type={type} onClick={handler} title={title} disabled={isDisabled} className={classes.join(' ')}>
      {btnLabel}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.node.isRequired,
  activeLabel: PropTypes.node,
  title: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit']),
  size: PropTypes.oneOf(['small', '' /* alias for normal */, 'medium', 'large']),
  color: PropTypes.oneOf([
    'white',
    'light',
    'dark',
    'black',
    'text',
    'primary',
    'link',
    'info',
    'success',
    'warning',
    'danger',
  ]),
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  handler: PropTypes.func.isRequired,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

Button.defaultProps = {
  activeLabel: '',
  type: 'button',
  size: '',
  title: '',
  color: 'link',
  isActive: false,
  isDisabled: false,
  isFullWidth: false,
  style: null,
  className: '',
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button.jsx